import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../api/client';

const download = async (d) => {
  const res = await api.get(d.download_url, { responseType: 'blob' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(res.data);
  a.download = `${d.title}.pdf`;
  a.click();
};

const MyDocuments = () => {
  const [docs, setDocs] = useState(null);
  const [holdings, setHoldings] = useState([]);

  const load = useCallback(async () => {
    try {
      const [d, h] = await Promise.all([api.get('/api/documents/my/'), api.get('/api/holdings/my/')]);
      setDocs(d.data); setHoldings(h.data);
    } catch (e) {
      toast.error('Failed to load documents');
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const sign = async (d) => {
    try {
      const res = await api.post('/api/esign/start/', { document: d.id });
      window.location.assign(res.data.redirect_url);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not start signing');
    }
  };

  if (!docs) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p>Loading…</p></main>;
  const group = (kind) => docs.filter((d) => d.kind === kind);
  const section = (title, kind, withSign) => (
    group(kind).length > 0 && (
      <>
        <h2>{title}</h2>
        <ul>{group(kind).map((d) => (
          <li key={d.id}>{d.title}{' '}
            {withSign && <button onClick={() => sign(d)}>Sign</button>}{' '}
            <button onClick={() => download(d)}>Download</button></li>
        ))}</ul>
      </>
    )
  );

  return (
    <main style={{ maxWidth: 900, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>My holdings and documents</h1>
      <h2>Holdings</h2>
      {holdings.length === 0 ? <p>No shares allotted yet.</p> : (
        <table>
          <thead><tr><th align="left">Company</th><th align="right">Shares</th><th align="right">% of allotted shares</th><th align="left">Certificate</th><th /></tr></thead>
          <tbody>{holdings.map((h) => (
            <tr key={h.certificate_no}>
              <td>{h.spv_name}</td><td align="right">{h.shares}</td><td align="right">{Number(h.holding_pct).toFixed(2)}%</td><td>{h.certificate_no}</td>
              <td>{h.certificate_document && <button onClick={() => download({ download_url: `/api/documents/${h.certificate_document}/download/`, title: `Certificate ${h.certificate_no}` })}>Download</button>}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
      {section('To sign', 'to_sign', true)}
      {section('Signed documents', 'signed', false)}
      {section('Issued documents', 'issued', false)}
      {section('Share certificates', 'certificate', false)}
      {docs.length === 0 && <p>No documents yet. Documents appear after your payment is received.</p>}
    </main>
  );
};

export default MyDocuments;
